import styled, { css } from 'styled-components'

export const ColumnistsWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    .columnist-name {
      color: ${theme.colors.primary};
      font-weight: 600;
    }
    .container-image {
      img {
        border-radius: 50%;
      }
    }
    .container-text {
      width: 85%;
    }
    .sora {
      font-family: 'Sora';
    }

    img {
      width: 40px;
      min-width: 40px;
      height: 40px;
      object-fit: cover;
    }

    .footer {
      width: 72px;
      min-width: 72px;
      height: 72px;
    }

    .culumnList {
      width: 152px;
      min-width: 152px;
      height: 152px;
    }
  `}
`
export const SendMessage = styled.div`
  button {
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    padding: 6px 9px;
  }
`
